export const iconFontAwesomeHumanitarianPumpSoap = (
	<i className="fa-solid fa-pump-soap"></i>
);
